import { Modelo } from '@ext/index';
import * as Types from './Item.types';
import * as Pedidos from '../';
import * as PublicacionML from '@lib/MercadoLibre/Publicaciones';
import * as PublicacionIntex from '@lib/Necxus/Publicaciones';
import moment, { Moment } from 'moment';
import { Articulo, Precio } from '../../../Articulos';
import { OpcionDePrecio } from '@/__env/lib/Articulos/Articulo.lib';

export class IItem extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Pedido: number = 0;
    public Cliente: number = 0;
    public Codigo: string = '';
    public Estado: Pedidos.Estados;
    public Tipo: Pedidos.Tipos = Pedidos.Tipos.Mostrador;
    public IdExterna: string = '';
    public IdVariacion: number = 0;
    public Cantidad: number = 0;

    public PrecioUnitario: PrecioUnitario = {
        AlicuotaIva: 0,
        Final: 0,
        Neto: 0,
    };

    public Importes: Importes = {
        Descuento: {
            Monto: 0,
            Porcentaje: 0,
        },
        IVA: 0,
        Final: 0,
        Neto: 0,
    };

    public Publicacion: PublicacionML.Publicacion | PublicacionIntex.Publicacion;
    public Articulo: Articulo;
    public PrecioFijado: Precio;

    public get Imagen(): string
    {
        if ( this.Publicacion )
            return this.Publicacion.Imagen;
        else if ( this.Articulo )
            return this.Articulo.Imagen;
    }

    public get esDesconocido(): boolean
    {
        if ( this.Articulo && this.Articulo.Existe )
            return false;
        return true;
    }

    public get Variacion()
    {
        if ( this.Publicacion && this.Publicacion instanceof PublicacionML.Publicacion && this.IdVariacion )
        {
            return this.Publicacion.Variaciones.find( x => x.Variacion == this.IdVariacion );
        }
    }

    public get Descripcion(): string
    {
        if ( this.Publicacion )
            return this.Publicacion instanceof PublicacionIntex.Publicacion ? this.Publicacion.Titulo : this.Publicacion.Titulo;
        else if ( this.Articulo )
            return this.Articulo.Descripcion;
        return 'CODIGO NO EXISTE';
    }

    public getJson(): any
    {
        let json: any = {};
        json.id = this.Id;
        if ( this.Articulo )
            json.codigo = this.Articulo.Id;
        else
            json.codigo = this.Codigo;

        json.cliente = this.Cliente;
        json.id_externa = this.IdExterna ? this.IdExterna : null;
        json.id_variacion = this.IdVariacion ? this.IdVariacion : null;
        json.cantidad = this.Cantidad;

        if ( this.PrecioFijado )
        {
            json.alicuota_iva = this.PrecioFijado.Alicuota;
            json.precio_unitario_neto = this.PrecioFijado.Lista.Neto;
            json.descuento = this.Importes.Descuento.Porcentaje;
            json.tipo_precio = this.PrecioFijado.Tipo;
            json.subtipo_precio = this.PrecioFijado.SubTipo;
            json.id_publicacion = this.PrecioFijado.IdPublicacion;
            json.fijado = this.PrecioFijado.Fijado ? 'S' : 'N';
        } else
        {
            json.alicuota_iva = this.PrecioUnitario.AlicuotaIva;
            json.precio_unitario_neto = this.PrecioUnitario.Neto;
            json.descuento = this.Importes.Descuento.Porcentaje;
            json.tipo_precio = this.Tipo.Id;
            //json.subtipo_precio = this.PrecioFijado.SubTipo;
            //json.id_publicacion = this.IdExterna;
        }


        return json;
    }



    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Pedido = !this.Json.pedido ? 0 : this.Json.pedido;
        this.Cliente = !this.Json.cliente ? 0 : this.Json.cliente;
        this.Codigo = !this.Json.codigo ? '' : this.Json.codigo;
        this.Estado = !this.Json.estado ? Pedidos.Estados.Creado : Pedidos.Estados.toTipo( this.Json.estado );
        this.Tipo = !this.Json.tipo ? Pedidos.Tipos.Mostrador : Pedidos.Tipos.toTipo( this.Json.tipo );
        this.IdExterna = !this.Json.id_externa ? '' : this.Json.id_externa;
        this.IdVariacion = !this.Json.id_variacion ? 0 : this.Json.id_variacion;
        this.Cantidad = !this.Json.cantidad ? 0 : this.Json.cantidad;
        this.PrecioUnitario.AlicuotaIva = !this.Json.alicuota_iva ? 0 : this.Json.alicuota_iva;
        this.PrecioUnitario.Neto = !this.Json.precio_unitario_neto ? 0 : this.Json.precio_unitario_neto;
        this.PrecioUnitario.Final = !this.Json.precio_unitario_final ? 0 : this.Json.precio_unitario_final;
        this.Importes.Descuento.Porcentaje = !this.Json.descuento ? 0 : this.Json.descuento;
        this.Importes.IVA = !this.Json.importe_iva ? 0 : this.Json.importe_iva;
        this.Importes.Descuento.Monto = !this.Json.importe_descuento ? 0 : this.Json.importe_descuento;
        this.Importes.Neto = !this.Json.total_neto ? 0 : this.Json.total_neto;
        this.Importes.Final = !this.Json.total_final ? 0 : this.Json.total_final;



        if ( this.Json.publicacion )
        {
            if ( this.Tipo.esMercadoLibre )
                this.Publicacion = new PublicacionML.Publicacion( this.Json.publicacion );
            else if ( this.Tipo.esTiendaIntex )
                this.Publicacion = new PublicacionIntex.Publicacion( this.Json.publicacion );
        }

        if ( this.Json.articulo )
        {
            this.Articulo = new Articulo( this.Json.articulo );
        }


        if ( this.Json.precio )
        {
            this.PrecioFijado = new Precio( this.Json.precio );
        } else
        {
            this.PrecioFijado = new Precio();
            this.PrecioFijado.Articulo = this.Codigo;
            this.PrecioFijado.Tipo = this.Json.tipo_precio;
            this.PrecioFijado.SubTipo = this.Json.subtipo_precio;
            this.PrecioFijado.IdPublicacion = this.Json.id_publicacion;
        }


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IItem )
    {
        this.Model = Model;
    }

    public Model: IItem;
}


type PrecioUnitario = {
    Neto: number,
    Final: number,
    AlicuotaIva: number;
};

type Importes = {
    IVA: number,
    Descuento: {
        Porcentaje: number,
        Monto: number,
    };
    Neto: number,
    Final: number,
};